//-------------------------------------------
//onload
//-------------------------------------------
window.addEventListener('load', (event) => { 
  setTimeout(() => {
    /** All pages */
    ada_buddha() 
  
    /** PLP */ 
    if (document.body.matches('.template-collection')){      
      ada_shogun()
    }

    /** PAGE */
    if (document.body.matches('.template-page')){
      ada_okeReviews()
      ada_shogun()
      ada_shogun_link()
    }

    /** ACCT */
    if (document.body.matches('.template-register')){
      ada_accountpages()      
    }
   

    /** APP/SHOP:  wholesale order form app */
    if (window.location.pathname.indexOf('apps/shop') > -1) {
      ada_orderform_page()
    }

    /** CONTACT */
    if (window.location.pathname.indexOf('contact') > -1){
      ada_contact()
    }

    /** RECHARGE */     
    if (window.location.pathname.indexOf('recurring/get-subscription-access') > -1){
      ada_recharge()
    }
  }, 2000);
})

//--------------------------------
// helpers
//--------------------------------
function elementFound(selector) { 
  return new Promise((resolve, reject) => {
    let el = document.querySelector(selector)
    if (el) {
      resolve(el)
    }else{
      // reject('ELEMENT NOT FOUND:' +  selector) 
    }
  }) 
}
function add_label(element, id){
  let newlabel = document.createElement("Label");
  newlabel.setAttribute("for", id);
  newlabel.innerHTML = id
  newlabel.classList.add('sr-only')
  element.setAttribute('id', id)
  element.parentNode.appendChild(newlabel)
}
function add_arialabel_to_element(id){
  elementFound(`#${id}`).then(( )=>{
    let elm = document.querySelector(`#${id}`)        
    if (elm) elm.setAttribute('aria-label', id)       
  }).catch(e => console.error('error: '+ e))    
}
//--------------------------------
// okeReviews
//--------------------------------
function ada_okeReviews(){
  let t= 'a.okeReviews-review-reviewer-product-thumbnail'
  elementFound(t).then(( )=>{
    let t_s = document.querySelectorAll(t)       
    setTimeout(() => {  
      t_s.forEach(e=>{
        e.setAttribute('aria-hidden', true)
      })
    }, 0);
  }).catch(e => console.error('error: '+ e))  
}

//--------------------------------
// APP/SHOP:  wholesale order form app 
//--------------------------------
function ada_orderform_page(){

  // add evt listner
  let t = "#spof-dropdown"
  elementFound(t).then(( )=>{
    let dropdown = document.querySelector(t)       
    setTimeout(() => {  
      dropdown.addEventListener('change', ()=>{
        // dynamic ada fix
        ada_wholesale_order_form_app()
      })
    }, 0);
  }).catch(e => console.error('error: '+ e)) 

  // initial ada fix
  ada_wholesale_order_form_app()

}

function ada_wholesale_order_form_app(){
  // add aria label
  let t1= 'spof-dropdown'
  add_arialabel_to_element(t1)  
  let t3= 'srch_pro_term'
  add_arialabel_to_element(t3) 
  
  // add img alt
  setTimeout(() => {
    let t2= '.Spof_image' 
    let t2_s = document.querySelectorAll(t2)  
    t2_s.forEach(e=>{
      if (e){          
        e.setAttribute('aria-hidden', true)       
      }      
    }) 
  }, 2000);

  //Table header contains no text
  let t4 = '#shopify_products_list table thead th'
  elementFound(t4).then(( )=>{
    let t4_s = document.querySelectorAll(t4)  
   
    if(t4_s[5]){
      let newlabel = document.createElement("span");
      newlabel.innerHTML = 'actions column'
      newlabel.classList.add('sr-only')
      t4_s[5].appendChild(newlabel)
    }
 
  }).catch(e => console.error('error: '+ e)) 

  // change bottom pagination btn ids
  let t5 = '.spof-paging-bottom .spof-btn-group button'
  elementFound(t5).then(( )=>{
    let btns = document.querySelectorAll(t5)
    btns.forEach(btn => {
      let id = btn.getAttribute('id') 
      btn.setAttribute("id", `${id}__bottom`)
    }) 
  }).catch(e => console.error('error: '+ e)) 

  //.prod-desc-image
  let t6 = '#popupDescreption img'
  elementFound(t6).then(( )=>{
    let img = document.querySelector(t6) 
    img.setAttribute("aria-hidden", "true")
  }).catch(e => console.error('error: '+ e)) 

  //.spof_close
  let t7 = '.spof_close'
  elementFound(t7).then(( )=>{
    let t7_s = document.querySelectorAll(t7) 
    t7_s.forEach(a => {
      a.setAttribute("aria-label", "close button")
    })    
  }).catch(e => console.error('error: '+ e)) 

}

//--------------------------------
// buddhaapps megamenu
//--------------------------------
function ada_buddha(){
  let t1 = '.mm-image img'
  elementFound(t1).then(( )=>{
    let t1_s = document.querySelectorAll(t1)      
    t1_s.forEach(e=>{ 
      let a = e.closest('a')
      if (a) {
        let a_label = a.getAttribute('aria-label')
        e.setAttribute('alt', a_label) 
      }
    })  
  }).catch(e => console.error('error: '+ e)) 
}

//--------------------------------
// shogun
//--------------------------------
function ada_shogun(){
  let t1 = '.shogun-image-link img'
  elementFound(t1).then(( )=>{
    let t1_s = document.querySelectorAll(t1)  
    t1_s.forEach(e=>{       
      if (e) { 
        if (e.getAttribute('alt') == null || e.getAttribute('alt') == ""){
          e.setAttribute('alt', "coffee am image | shogun ") 
        } 
        let img_link = e.closest(".shogun-image-link")       
        if (img_link){
          if (img_link.getAttribute('aria-label') && img_link.getAttribute('aria-label').length < 1){
            img_link.setAttribute('aria-label', "coffee am image link") 
          }
        }
      }
    })  
  }).catch(e => console.error('error: '+ e)) 
}

//--------------------------------
// Contact page
//--------------------------------
function ada_contact(){ 
  let t2 = 'area'
  elementFound(t2).then(( )=>{
    let elm = document.querySelector(t2)        
    if (elm) elm.setAttribute('alt', 'map area')       
  }).catch(e => console.error('error: '+ e))    
}


//--------------------------------
// Account pages
//--------------------------------
function ada_accountpages(){
  let t1 = '.customr-control-label'
  elementFound(t1).then(( )=>{
    let t1_s = document.querySelectorAll(t1)

    // find these 4 labels, add id to its parent manually
    const array = ['Individual or a Commercial', 'Sign up for', 'may send you special offers', 'Products of interest'];
    const matches = function(txt){
      return array.filter(element => { 
        if (txt.indexOf(element) !== -1) 
          return true;
      });
    }
    t1_s.forEach(e=>{
      let txt = e.innerHTML.trim() 
      if (matches(txt).length > 0 ){ 
        let id = e.getAttribute('for')        
        let target = e.closest('.customr-field')        
        if (target) 
          target.setAttribute("id", id) 
      }
    })
  }).catch(e => console.error('error: '+ e)) 
}  

//--------------------------------
// Recharge
//--------------------------------
function ada_recharge(){  
  // add label
  let t1 = '#customer_email'
  elementFound(t1).then(( )=>{
    let t1_e = document.querySelector(t1)
    if (t1_e){
      t1_e.setAttribute('aria-label','customer email')
    }    
  }).catch(e => console.error('error: '+ e)) 

  // rm duplicated head title
  let t2 = '#site-main > title'
  elementFound(t2).then(( )=>{
    let t2_e = document.querySelector(t2)
    if (t2_e){
      t2_e.remove()
    }    
  }).catch(e => console.error('error: '+ e)) 

}

function ada_shogun_link() { 
  let t2 = '.template-page .shg-category-grid a'
  elementFound(t2).then(() => {
    let elms = document.querySelectorAll(t2)
    elms.forEach(elm => {
      if (elm) {
        if (!elm.getAttribute('href')) {
          elm.setAttribute('href', '#')
        }
      } 
    })              
  }).catch(e => console.error('error: '+ e))    
}
